import { watch } from 'vue'
import { useFrontegg } from '@frontegg/vue'
import { setDatadogUser, clearDatadogUser } from '@/util/datadogRum'
import { CONFIG } from '@/config/index'

/**
 * Composable to manage Datadog RUM user identification
 * Automatically updates user context when authentication state changes
 */
export function useDatadogRum() {
  const { authState } = useFrontegg()

  // Watch for authentication state changes and update Datadog RUM user
  watch(
    () => [authState.isAuthenticated, authState.user],
    ([isAuthenticated, user]) => {
      // Only update in production and if Datadog is configured
      if (import.meta.env.MODE !== 'prod' || !CONFIG.DATADOG.applicationId || !CONFIG.DATADOG.clientToken) {
        return
      }

      if (isAuthenticated && user && typeof user === 'object') {
        setDatadogUser({
          id: (user as { userId?: string; id?: string }).userId || (user as { id?: string }).id,
          email: (user as { email?: string }).email,
          name: (user as { name?: string; email?: string }).name || (user as { email?: string }).email,
        })
      } else {
        clearDatadogUser()
      }
    },
    { immediate: true },
  )
}
